import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NavTabs = props => {
  const handleClick = tab => () => {
    if (tab.onClick) {
      tab.onClick(tab);
      return;
    }
    if (props.onClick) props.onClick(tab);
  };
  return (
    <ul className="nav nav-tabs">
      {props.tabs.map(tab => (
        <li className="nav-item">
          <button
            className={classNames('nav-link', { active: tab.active })}
            onClick={handleClick(tab)}
            tabIndex="0"
          >
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  );
};
NavTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func.isRequired,
      active: PropTypes.bool,
      label: PropTypes.oneOf(PropTypes.string, PropTypes.node),
    }),
  ),
};

NavTabs.defaultProps = {
  tabs: [],
};

export default NavTabs;
